import React from "react";
import { Container, ButtonsArea } from "./Styled";
import { Formik, Form, FormikValues } from "formik";
import { Input } from "formik-antd";
import { Alert, Card } from "antd";
import * as Yup from "yup";
import { useIntl } from 'react-intl';
import { useDispatch } from "react-redux";
import SaveButton from "../../system/saveButton/SaveButton";
import { saveBotAction } from "../../../business/actions/botActions";
import { Bot } from "../../../model/bot/types";

type BotFormProps = {
};

const BotSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required')
});

const BotForm: React.FunctionComponent<BotFormProps> = () => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const save = (values: FormikValues) => {
        const newBot: Bot = {
            name: values.name,
            flowListId: []
        };
        dispatch(saveBotAction.request(newBot))
    }

    return (
        <Container>
            <Formik
                validationSchema={BotSchema}
                enableReinitialize
                initialValues={{ name: "" }}
                onSubmit={(values) => {
                    save(values);
                }}
                render={({ values, errors, touched }) => {
                    return <Form>
                        <Input name='name' value={values.name} placeholder="Nom"></Input>
                        {errors.name && touched.name ? (
                            <Alert message={errors.name} type="error" showIcon />
                        ) : null}
                        <ButtonsArea>
                            <SaveButton />
                        </ButtonsArea>
                    </Form>
                }}
            />
        </Container>
    );
};

export default BotForm;